import type { RedirectToResult, Transition } from "@uirouter/core";

import { objectKeys } from "app/helpers/objects";
import {
    MANAGE_INTEGRATION_ROUTE,
    MANAGEMENT_CRM_INTEGRATIONS_ROUTE,
} from "app/pages/sales-intelligence/constants/sl_routes";
import { CRM_STATUS_CONFIG } from "app/pages/sales-intelligence/modules/manage-integrations/constants/crm";
import {
    manageIntegrationsQueryKeys
} from "app/pages/sales-intelligence/modules/manage-integrations/query/key-factory/factory";
import { INTEGRATION_STATUS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import { SwRedux } from "app/services/SwRedux";
import queryClient from "single-spa/react-app/query-client";
import type { ThunkDispatchCommon } from "single-spa/store/types";

import { getAccessToCRMs } from "./getAccessToCRMs";

const INTEGRATIONS = objectKeys(CRM_STATUS_CONFIG);

export async function crmManagementTransitionHook(transition: Transition): Promise<RedirectToResult> {
    const { stateService } = transition.router;
    const dispatch = SwRedux.getInstance().dispatch as ThunkDispatchCommon;

    const accessToCRMs = getAccessToCRMs();

    const results = await Promise.allSettled(
        INTEGRATIONS.map((name) =>
            queryClient.ensureQueryData({
                queryKey: manageIntegrationsQueryKeys.byIntegration(name),
                queryFn: () => dispatch(CRM_STATUS_CONFIG[name].getStatusThunk(false)),
                staleTime: Infinity,
            }),
        ),
    );

    const integratedNames = INTEGRATIONS.filter((integrationName, idx) => {
        const result = results[idx];
        return result.status === "fulfilled" && result.value && result.value !== INTEGRATION_STATUS.NotIntegrated && accessToCRMs[integrationName];
    });

    const singleIntegrated = integratedNames.length === 1 ? integratedNames[0] : undefined;

    const targetState =
        (singleIntegrated && MANAGE_INTEGRATION_ROUTE[singleIntegrated]) ?? MANAGEMENT_CRM_INTEGRATIONS_ROUTE;

    return stateService.target(targetState, transition.params(), { location: "replace" });
}
